<script>
import Intersect from 'vue-intersect';

export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  methods: {
    intersected() {
      this.$impressions.add(this.id);
    },
  },
  render(createElement) {
    return createElement(Intersect, {
      props: {
        threshold: [1],
      },
      on: {
        enter: this.intersected,
      },
    }, this.$slots.default);
  },
};
</script>
